import React from 'react';
import './selectOutlet.style.scss';
import classNames from 'classnames';
interface ISelectOutletProps extends React.HTMLProps<HTMLSelectElement> {
  label: string;
  required?: boolean;
  errors?: string;
  name: string;
  touched?: boolean;
  options: Array<IOption>;
}

const SelectOutlet = ({
  label,
  required = false,
  errors,
  touched,
  name,
  disabled,
  options,
  ...props
}: ISelectOutletProps) => {
  return (
    <div
      className={`floating-label-select container ${
        disabled ? 'disabled' : ''
      }`}
    >
      {' '}
      <select
        id={name}
        name={name}
        data-value={props.value}
        {...props}
        disabled={disabled}
        aria-expanded={props.value !== ''}
        value={props.value}
        className={classNames(
          (touched && errors && !disabled ? 'invalid ' : '') +
            (touched && !errors && !disabled ? 'valid ' : ''),
        )}
      >
        <option></option>
        {React.Children.toArray(
          options?.map((item, index) => (
            <>
              <option key={index} value={item.value}>
                {item.label}
              </option>
            </>
          )),
        )}
      </select>
      <label htmlFor={name}>
        {label} {required && <span className=" text-red-400">*</span>}
      </label>
      {touched && errors && (
        <>
          <div className="pt-1">
            <small>
              <i className="icon-warning"></i> {errors}
            </small>
          </div>
        </>
      )}
    </div>
  );
};

export default SelectOutlet;
